@if (!loading) {
<div class="container">
    <div>
        <h4>ACS:</h4>
        <div>
            <div 
            [ngClass]="{'green': acsBoolStatus === true, 'red': acsBoolStatus === false, 'space-grey': acsBoolStatus === null}"
            class="dot"></div>
            <p>{{ acsStatus }}</p>
        </div>
        <div>
            <mat-icon>query_builder</mat-icon>
            <p>{{ acsBoolStatus == null ? "Never" : lastInform | timeAgo}}</p>
        </div>
    </div>
    <div>
        <h4>Ping:</h4>
        <div>
            <div 
            [ngClass]="{'green': pingBoolStatus === true, 'red': pingBoolStatus === false, 'space-grey': pingBoolStatus === null}"
            class="dot"></div>
            <p>{{ pingStatus }}</p>
        </div>
        <div>
            <mat-icon>query_builder</mat-icon>
            <p>{{ pingBoolStatus == null ? "Never" : lastPing | timeAgo}}</p>
        </div>
    </div>
    <div>
        <h4>Snapshot:</h4>
        <div>
            <div
            [ngClass]="{'green': snapshotBoolStatus === true, 'red': snapshotBoolStatus === false, 'space-grey': snapshotBoolStatus === null}"
            class="dot"></div>
            <p>{{ snapshotStatus }}</p>
        </div>
        <div>
            <mat-icon>query_builder</mat-icon>
            <p>{{ snapshotBoolStatus == null ? "Never" : lastSnapshot | timeAgo}}</p>
        </div>
    </div>
</div>
}
@if (loading) {
<mat-progress-bar color="loader" class="loader" mode="indeterminate"></mat-progress-bar>
}
